export class OperatorEditModel {
  constructor(id, firstName, lastName, email, role) {
    this.id = id || null;
    this.firstName = firstName || '';
    this.lastName = lastName || '';
    this.email = email || '';
    this.role = role || null;
  }
}
